module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mode) ? _c('div', {
    staticClass: "single"
  }, [_c('div', {
    staticClass: "droplet-container"
  }, _vm._l((_vm.quantity), function(drop, i) {
    return _c('i', {
      staticClass: "droplet",
      class: _vm.scores.playerOne.history[i]
    })
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.mode) ? _c('div', {
    staticClass: "multi"
  }, [_c('div', {
    staticClass: "droplet-container"
  }, _vm._l((_vm.quantity), function(drop, i) {
    return _c('i', {
      staticClass: "droplet",
      class: _vm.scores.playerOne.history[i]
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "droplet-container"
  }, _vm._l((_vm.quantity), function(drop, i) {
    return _c('i', {
      staticClass: "droplet",
      class: _vm.scores.playerTwo.history[i]
    })
  }), 0)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f8476b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScoreDots.vue
// module id = 50
// module chunks = 0